import { render, staticRenderFns } from "./previewTable.vue?vue&type=template&id=6fa5fdb4&scoped=true"
import script from "./previewTable.vue?vue&type=script&lang=js"
export * from "./previewTable.vue?vue&type=script&lang=js"
import style0 from "./previewTable.vue?vue&type=style&index=0&id=6fa5fdb4&prod&lang=less&scoped=true"
import style1 from "./previewTable.vue?vue&type=style&index=1&id=6fa5fdb4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa5fdb4",
  null
  
)

export default component.exports